import React, { FC, ReactNode, useCallback } from 'react';
import { FieldRenderProps } from 'react-final-form';

import { Checkbox } from 'Modules/ui3/components/Checkbox';
import { CheckboxWithLabel, CheckboxWithLabelProps } from 'Modules/ui3/components/CheckboxWithLabel';


type CheckboxProps = Omit<CheckboxWithLabelProps, 'label'> & {
    label?: ReactNode;
}

export type CheckboxFieldProps = FieldRenderProps<boolean> & CheckboxProps & {
    mutate?: (event) => void;
};

export const CheckboxField: FC<CheckboxFieldProps> = ({
    input: { onChange, ...input },
    meta,
    mutate,
    label,
    ...props
}) => {
    const onChangeMutate = useCallback(
        event => {
            onChange(event.target.checked);
            if (mutate)
                mutate(event.target.checked);
        },
        [mutate, onChange],
    );
    return label ? (
        <CheckboxWithLabel label={label} onChange={onChangeMutate} {...input} {...props} />
    ) : (
        <Checkbox color='primary' onChange={onChangeMutate} {...input} {...props} />
    );
};
